// (The old GamePanel-only 'gamemode' theme was removed in the 2026-08 declutter.)
export type MusicTheme = 'main' | 'adventure' | 'jungle' | 'neutral' | 'focus' | 'arcade';

// Relaxed-island tracks for the arcade (owner 2026-08-12: game music "too fast" —
// the old ArchadeModeTheme/arcadebrightaction set measured ~148-167 BPM, the
// fastest in the corpus). Now the SAME calm JUNGLE-Adventure set (~63-102 BPM)
// web-child's arcade theme uses, served from public/music/jungle-adventure/.
const JUNGLE_ADVENTURE = [
  'JUNGLE-Adventure-v1.mp3', 'JUNGLE-Adventure-v2.mp3', 'JUNGLE-Adventure-v3.mp3',
  'JUNGLE-Adventure-v4.mp3', 'JUNGLE-Adventure-v5.mp3', 'JUNGLE-Adventure-v6.mp3',
];

export const THEME_VARIATIONS: Record<MusicTheme, string[]> = {
  main: [
    'ADVENTURE-v1.mp3', 'ADVENTURE-v2.mp3', 'ADVENTURE-v3.mp3',
    'ADVENTURE-v4.mp3', 'ADVENTURE-v5.mp3', 'ADVENTURE-v6.mp3',
  ],
  adventure: [
    'ADVENTURE-v1.mp3', 'ADVENTURE-v2.mp3', 'ADVENTURE-v3.mp3',
    'ADVENTURE-v4.mp3', 'ADVENTURE-v5.mp3', 'ADVENTURE-v6.mp3',
  ],
  jungle: [
    'JUNGLE-v1.mp3', 'JUNGLE-v2.mp3', 'JUNGLE-v3.mp3',
    'JUNGLE-v4.mp3', 'JUNGLE-v5.mp3', 'JUNGLE-v6.mp3',
  ],
  neutral: [
    'main-v1.mp3', 'main-v2.mp3', 'main-v3.mp3',
    'main-v4.mp3', 'main-v5.mp3', 'main-v6.mp3',
  ],
  focus: [
    'Neutral-v1.mp3', 'Neutral-v2.mp3', 'Neutral-v3.mp3',
    'Neutral-v4.mp3', 'Neutral-v5.mp3', 'Neutral-v6.mp3',
  ],
  // Relaxed island music — matches web-child's arcade theme (single sound
  // across hosts; the frantic ArchadeModeTheme/arcadebrightaction set is retired).
  arcade: JUNGLE_ADVENTURE,
};

/**
 * Resolve base music theme from saved learning style preference.
 * arcade is triggered contextually by pages, not preferences.
 */
export function resolveTheme(learningStyle: string): MusicTheme {
  switch (learningStyle) {
    case 'fun':      return 'main';
    case 'animals':  return 'jungle';
    case 'grown-up': return 'focus';
    default:         return 'neutral';
  }
}

/** The public folder a theme's mp3s live in (arcade uses jungle-adventure —
 *  same mapping as web-child/src/music/manifest.ts). The legacy 'adventure'
 *  theme plays the ADVENTURE-v* files, which live in main/ (there is no
 *  deployed adventure/ folder — a latent 404). */
export function musicFolder(theme: MusicTheme): string {
  if (theme === 'arcade') return 'jungle-adventure';
  if (theme === 'adventure') return 'main';
  return theme;
}

export function trackUrl(theme: MusicTheme, filename: string): string {
  return `/music/${musicFolder(theme)}/${filename}`;
}
